const shortid = require('shortid');

function generateRandomKey(prefix = '') {
	return `${[prefix, shortid.generate()].filter(s => !!s).join('_')}`;
}

module.exports = {
	generateRandomKey,
};
